"use client";

import Script from 'next/script';

export default function GoogleReviewBadge() {
  return (
    <>
      <Script id="google-customer-reviews-init" strategy="afterInteractive">
        {`
          window.renderBadge = function() {
            // 防止重复渲染：如果已经存在徽章容器，则不再创建
            if (document.getElementById("google-rating-badge-container")) return;

            var ratingBadgeContainer = document.createElement("div");
            ratingBadgeContainer.id = "google-rating-badge-container";
            document.body.appendChild(ratingBadgeContainer);

            window.gapi.ratingbadge.render(ratingBadgeContainer, {
              "merchant_id": "7552790",
              "position": "BOTTOM_LEFT"
            });
          }
        `}
      </Script>
      <Script
        src="https://apis.google.com/js/platform.js?onload=renderBadge"
        strategy="lazyOnload"
      />
    </>
  );
}